import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

// Schemas
const homeFilterSchema = Yup.object().shape({
  sort_light_rating: Yup.string().oneOf(['htl', 'lth']),
  denominations: Yup.array().of(Yup.string()),
  programs: Yup.array().of(Yup.string()),
  religions: Yup.array().of(Yup.string()),
  distance: Yup.number()
  // rating: Yup.number()
});

// Types
export type HomeFilterData = Yup.InferType<typeof homeFilterSchema>;

// Resolvers
export const homeFilterResolver = yupResolver(homeFilterSchema);
